import React, { Fragment, useState, useEffect } from "react";
import man from "../../../assets/images/dashboard/user.png";
import { User, Mail, Lock, Settings, LogOut } from "react-feather";
import { Link, useNavigate } from "react-router-dom";
import { EditProfile, Inbox, LockScreen } from "../../../constant";
import { useSelector } from "react-redux";
import { LOGOUT } from "../../../redux/actionTypes";
import { useDispatch } from "react-redux";
import { showToast } from "../../ToastifyNotification";

const UserMenu = () => {
  const [profile, setProfile] = useState("");
  // auth0 profile
  const isAuthenticated = useSelector(state => state?.authReducer?.isAuthenticated || false);
  const user = useSelector(state => state?.authReducer?.user || {});
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    setProfile(localStorage.getItem("profileURL") || man);
  }, []);

  const handleLogout = () => {
    dispatch({
      type: LOGOUT
    })
    showToast('success', 'Logout Successfully');
    navigate(`/login`);
  };

  if (!isAuthenticated) {
    return null;
  }

  return (
    <Fragment>
      <li className="onhover-dropdown">
        <div className="d-flex align-items-center">
          {/* <img
            className="align-self-center pull-right img-50 rounded-circle blur-up lazyloaded"
            src={ profile}
            alt="header-user"
          /> */}
          {user?.userName}
          <div className="dotted-animation">
            <span className="animate-circle" />
            <span className="main-circle" />
          </div>
        </div>
        <ul className="profile-dropdown onhover-show-div p-20 profile-dropdown-hover">
          {/* <li>
            <Link to={`/users/userEdit`}>
              <User />
              {EditProfile}
            </Link>
          </li> */}
          {/* <li><Link to={`/email-app/emailDefault`}><Mail />{Inbox}</Link></li>
                    <li><a href="#javascript"><Lock />{LockScreen}</a></li>
                    <li><a href="#javascript"><Settings />{"Settings"}</a></li> */}
          <li>
            <a
              onClick={(e)=>{e.preventDefault();handleLogout();}}
              href="#"
            >
              <LogOut />
              Log out
            </a>
          </li>
        </ul>
      </li>
    </Fragment>
  );
};

export default UserMenu;
